import { useTranslation } from "react-i18next";
import { Company } from "@/types";
import { Grid } from "@mantine/core";
import Text from "@/components/atoms/Text";
import DnbRiskLevel from "../../../DnbRiskLevel";

interface AMLandKYCTabProps {
  company: Company;
}

export default function AMLandKYCTab({ company }: AMLandKYCTabProps) {
  const { t } = useTranslation();

  return (
    <>
      <Grid p="lg">
        <Grid.Col span={4}>
          <Text color="secondary" size="sm">
            {t("commonAdmin:dnbRiskLevel")}
          </Text>
        </Grid.Col>
        <Grid.Col span={8}>
          <DnbRiskLevel level={company.companyRisk} />
        </Grid.Col>

        <Grid.Col span={4}>
          <Text color="secondary" size="sm">
            {t("commonAdmin:financialRisk")}
          </Text>
        </Grid.Col>
        <Grid.Col span={8}>
          <Text size="sm">{company.companyFinancialRisk ?? "-"}</Text>
        </Grid.Col>
      </Grid>
    </>
  );
}
